import React from 'react';
import { SectionHeading } from './SectionHeading';
import { SectionCta } from './SectionCta';
import { planSteps } from '../data/content';
const targets = [{
  value: '10+',
  label: 'standardized professional checklists'
}, {
  value: '5+',
  label: 'reusable case / workflow templates'
}, {
  value: '1',
  label: 'complete end-to-end workflow map'
}];
export function ImplementationPlan() {
  return <section className="bg-white px-4 py-16 sm:py-24" data-id="element-205" data-mp="3jmpm6l5xx7d4">
      <div className="mx-auto max-w-3xl" data-id="element-206" data-mp="3jk3gkr2m11xj">
        <SectionHeading eyebrow="A very specific 30-day target" title={<>Don’t just download it. <em className="text-gold-dark" data-id="element-208" data-mp="3tb7lexykn6en">Build it.</em></>} data-id="element-207" data-mp="3ok90fl2n1k52" />
        <p className="mx-auto mt-5 max-w-xl text-center text-lg leading-relaxed text-ink/70" data-id="element-209" data-mp="3tdu0dinsko6w">
          I don’t want you to download another PDF and forget about it. Over the next 30 days, build at least:
        </p>

        <div className="mt-10 grid gap-3 sm:grid-cols-3" data-id="element-210" data-mp="b64bmzxnu67w">
          {targets.map(t => <div key={t.label} className="flex items-center gap-4 rounded-2xl bg-ink p-5 sm:flex-col sm:items-start" data-id="element-211" data-mp="b3ryr16rem1p">
              <span className="font-serif text-5xl font-black leading-none text-gold-light" data-id="element-212" data-mp="2wf2rfk62qp44">{t.value}</span>
              <span className="text-[16px] font-semibold leading-snug text-white" data-id="element-213" data-mp="2rf80xhq7o1jl">{t.label}</span>
            </div>)}
        </div>

        <p className="mx-auto mt-8 max-w-xl text-center text-[17px] leading-relaxed text-ink/70" data-id="element-214" data-mp="2mihiwouuivvj">
          Not perfection. Not changing everything overnight.{' '}
          <strong className="text-ink" data-id="element-215" data-mp="3f52a9pbbn7z3">Building your system one process at a time.</strong>
        </p>

        <h3 className="mt-16 text-center font-serif text-3xl font-black text-ink" data-id="element-216" data-mp="3adk84xxkb1cj">Here’s how I would use it</h3>
        <ol className="relative mt-8 space-y-4 before:absolute before:bottom-6 before:left-[27px] before:top-6 before:w-0.5 before:bg-gold/40" data-id="element-217" data-mp="35epqhzbbziu0">
          {planSteps.map((s, i) => <li key={s.days} className="relative flex items-center gap-4" data-id="element-218" data-mp="1yir44zy87r1" data-mpi={i}>
              <span className="z-10 flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-gold font-serif text-xl font-black text-ink ring-4 ring-white" data-id="element-219" data-mp="1w6waahqzgc0k">
                {i + 1}
              </span>
              <div className="flex-1 rounded-2xl bg-cream px-4 py-3.5 ring-1 ring-ink/10" data-id="element-220" data-mp="1mhcmqysbrtzd">
                <p className="text-xs font-black uppercase tracking-wider text-gold-dark" data-id="element-221" data-mp="1rfe6zn1hlzcf">{s.days}</p>
                <p className="mt-0.5 text-[17px] font-semibold leading-snug text-ink" data-id="element-222" data-mp="1ci5bqi92cbff">{s.task}</p>
              </div>
            </li>)}
        </ol>
        <p className="mt-8 text-center font-serif text-2xl font-bold text-ink" data-id="element-223" data-mp="1hfnaxgxa3ca8">Thirty days. One system.</p>

        <SectionCta label="Start my 30-day implementation" data-id="element-224" data-mp="13kbhrdyrttvf" />
      </div>
    </section>;
}